import { Pressable, View } from 'react-native'
import { styled } from '~/utils'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      position: 'relative',
      justifyContent: 'center',
      gap: theme.spacingInlineTwopulse,
      padding: theme.spacingInlineFourpulse,
      minWidth: theme.sizingColossal + theme.sizingColossal,
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorNone,
      borderWidth: theme.borderWidthNone,
      borderRadius: 0,
    },
    variants: {
      isPressed: {
        true: {
          backgroundColor: theme.colorContainerFillPressed,
          borderColor: theme.colorNone,
          borderWidth: theme.borderWidthNone,
          borderRadius: theme.borderRadiusNone,
        },
      },
      isFocused: {
        true: {
          borderColor: theme.colorContainerBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
    },
  }
})

export const Line = styled(View, theme => {
  return {
    base: {
      height: 1,
      position: 'absolute',
      bottom: 0,
      left: theme.spacingInlineFourpulse,
      right: theme.spacingInlineFourpulse,
      backgroundColor: theme.colorFillNeutralFallback,
      borderColor: theme.colorNone,
      borderWidth: theme.borderWidthNone,
      borderRadius: theme.borderRadiusTinycontainer,
    },
    variants: {},
  }
})
